import theme from 'src/styles/theme'
import styled, { css } from 'styled-components'

export const styledLastFraction = {
  fontWeight: 'bold',
}

export const FinishFractionFormWrapper = styled.div`
  padding: 1rem;
`

export const FieldAdornment = styled.div`
  position: absolute;
  right: 12px;
  color: ${theme.colors.gray3};
`

export const CustomField = {
  border: 0,
  borderBottom: `3px solid ${theme.colors.darkBlue}`,
  width: '100%',
}

export const FlexDiv = styled.div<{ flexDirection?: string, align?: string, justify?: string, gap?: string }>`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || 'row'};
  align-items: ${(props) => props.align || 'none'};
  justify-content: ${(props) => props.justify || 'none'};

  ${(props) =>
    ((props.gap && !props.flexDirection) ? css`
      column-gap: ${props.gap};
    ` : css`
      row-gap: ${props.gap};
    `)
}
`
